import { Fragment, useState, useMemo } from 'react';
import { Box, Collapse, Stack, Typography, useTheme } from '@mui/material';
import _ from 'lodash';
import { FormProvider, useForm } from 'react-hook-form';
import SimpleTable from '../../simpleTable/SimpleTable.component';
import TableBodyItemsEditable from './components/TableBodyItemsEditable.component';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const TableItemsEditable = ({
  data,
  setSuccessEdit = () => {},
  checked,
  onSelectItem = () => {},
  isSelectable = false,
  onSelectAll = () => {},
  height = 450,
  label,
  module,
  open = false,
  toggleRow = () => {},
}) => {
  const methods = useForm();
  const theme = useTheme();
  const [orderBy, setOrderBy] = useState(
    'attributes.id_logbook.data.attributes.id_supplier.data.attributes.label'
  );
  const [order, setOrder] = useState('asc');

  const sortedData = useMemo(
    () => _.orderBy(data, [orderBy], [order]),
    [data, order, orderBy]
  );

  const numSelected = useMemo(
    () => _.keys(_.pickBy(checked, _.identity))?.length,
    [checked]
  );

  const handleSort = (columnId) => {
    const isAsc = orderBy === columnId && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(columnId);
  };

  return (
    <FormProvider {...methods}>
      <Fragment>
        {label && (
          <Stack
            pt={2}
            pb={2}
            pl={1}
            backgroundColor={theme.palette.secondary.contrastText}
            sx={{ borderRadius: `5px 5px 0px 0px`, cursor: 'pointer' }}
            onClick={() => toggleRow(label)}
            direction='row'
            alignItems={'center'}
            spacing={2}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            <Box display={'flex'}>
              Available
              <Typography fontWeight={'bold'} pl={1}>
                {label}
              </Typography>
            </Box>
          </Stack>
        )}

        <Collapse in={open} timeout='auto' unmountOnExit>
        
          <SimpleTable
            module={module}
            height={height}
            maxHeight={height}
            numSelected={numSelected}
            onSort={handleSort}
            order={order}
            orderBy={orderBy}
            isChecked={data?.length > 0 && data?.length === numSelected}
            onSelectAll={onSelectAll}
            data={sortedData}
            body={
              <TableBodyItemsEditable
                data={sortedData}
                module={module}
                checked={checked}
                onSelectItem={onSelectItem}
                setSuccessEdit={setSuccessEdit}
                isSelectable={isSelectable}
              />
            }
          />
        </Collapse>
      </Fragment>
    </FormProvider>
  );
};
export default TableItemsEditable;
